<template>
    <div class="fixed inset-0 bg-black bg-opacity-30 z-[99999] cursor-pointer backdrop-blur-sm">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'BackPanel',
};
</script>